import { useState, useRef, useEffect } from 'react';
import Container from './../../components/Layout/Container';
import PageTopBanner from './../../components/PageTopBanner';

import { TabsLink } from './../../components/Tab/Tabs';
import { communityData } from './../../components/Tab/TabData';

import { Calendar, DateObject } from 'react-multi-date-picker';
import DatePickerLocales_ko from '../../components/DatePicker/DatePickerLocales_ko';
import '../../components/DatePicker/datePickerCustom.css';

import { fetchGet } from '../../hooks/fetch';
import Loading from '../Loading';

export default function Schedule() {
	const [isDailyLoading, setDailyLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '일정';

	// 캘린더
	const date = new DateObject();
	const [dateValue, setDateValue] = useState(date);
	const [events, setEvents] = useState([]);
	const [selected, setSelected] = useState(dateValue);

	// 선택한 날짜의 이벤트 정보
	const [dayEvents, setDayEvents] = useState({});

	// 날짜 선택시 스크롤 이동
	const calendarRef = useRef(null);
	const onMoveToCalendar = () => {
		calendarRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	// 선택한 날짜의 일정 목록
	function handleScheduleEvent(targetDate) {
		setDailyLoading(true);
		setSelected(targetDate.format('YYYY년 MM월 DD일'));
		getDaily(targetDate.format('YYYY-MM-DD'));
		onMoveToCalendar();
	}

	function getDaily(targetDate) {
		const [year, month, day] = targetDate.split("-");

		fetchGet(
			`/schedule/daily?year=${year}&month=${month}&day=${day}`,
			(json) => {
				setDayEvents(json.items);
				setDailyLoading(false);
			}
		)
	}

	function getMonthly(targetDate) {
		const date = targetDate || dateValue;

		fetchGet(
			`/schedule/monthly?year=${date.year}&month=${date.month}`,
			(json) => {
				setEvents(json.schedules);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getMonthly(dateValue);
		handleScheduleEvent(dateValue);
	}, []);

	return (
		<main id="community-page-wrap">
			<h1 className="sr-only">{`${pageName} 목록 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={communityData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div
							ref={calendarRef}
							className="gs-full-calendar-con"
							style={{ scrollMarginTop: '100px' }}
						>
							{isLoading ?
								<Loading />
								:
								<Calendar
									showOtherDays
									shadow={false}
									locale={DatePickerLocales_ko}
									formatMonth={(month, year) => month}
									formatYear={(year, month) => year + '년'}
									monthYearSeparator=" "
									format="YYYY-MM-DD"
									value={dateValue}
									onMonthChange={(d) => {
										const newDate = new DateObject(d);
										setDateValue(newDate);
										getMonthly(newDate);
										getDaily(newDate.format('YYYY-MM-DD'));
									}}
									// 일별 이벤트 표시
									mapDays={({ date }) => {
										const showdDate = date.format("YYYY-MM-DD");
										const count = events[showdDate] || 0;

										return {
											children: (
												<>
													<i className="day">{date.format('D')}</i>
													{count > 0 && <i className='event-count'>+{count}</i>}
												</>
											),
										};
									}}
									onChange={(date) => handleScheduleEvent(date)}
								>
									<button
										className="rmdp-calendar-today-btn"
										onClick={() => {
											const today = new DateObject(); 
											setIsLoading(true);
											setDateValue(today);
											getMonthly(today);
											handleScheduleEvent(today);
										}}
									>
										오늘
									</button>
								</Calendar>
							}
						</div>

						<div className="schedule-detail-info-con">
							{(dayEvents !== null && dayEvents?.length > 0) ? (
								<>
									<div className="date">{selected}</div>
									<ul className="list">
										{dayEvents?.map((event, i) => (
											<li key={i}>
												<div className="item-1">
													<span>{event.time}</span>
													<span>{event.createdBy}</span>
												</div>
												<div className="item-2">{event.name}</div>
											</li>
										))}
									</ul>
								</>
							) : (
								isDailyLoading ? <Loading /> : <div className="gs-no-con">등록된 일정이 없습니다.</div>
							)}
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
